module.exports = __webpack_public_path__ + "img/logo.d73d9fb2.jpg";